import FlexBox from '@/atomic-components/FlexBox';
import {
	ICartItem,
	TCartValueAddedServices,
	VAS_TYPES,
} from '@/services/cart/models/cart';
import { getColor } from '@/utils/theme/colors';
import { Box } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { DSelectedItemsForParticularVasType } from '.';
import VasApplicableCartItems from '../VasApplicableCartItems';
import VasDescriptionCard from '../VasDescriptionCard';

type TVasCustomizationProps = {
	vasTypeIndex: number;
	vas?: TCartValueAddedServices;
	itemsGroupedByVasID: (ICartItem[] | undefined)[];
	selectItem: (item: ICartItem) => void;
	selectedItemsForSelectedVasType: DSelectedItemsForParticularVasType;
};

const VasCustomization = (props: TVasCustomizationProps) => {
	return (
		<Box>
			<FlexBox justifyContent='flex-start' width='100%' mt='8px'>
				<LencoTypography
					variant='P_SemiBold'
					sx={{
						color: getColor('Gray 0'),
					}}
				>
					Customize VAS
				</LencoTypography>
				{/* <LencoTypography
					variant='P_SemiBold'
					sx={{
						color: getColor('Gray 0'),
					}}
				>
					{props.vasTypeIndex}/2
				</LencoTypography> */}
			</FlexBox>
			{props.vas && (
				<Box mt='16px'>
					<VasDescriptionCard vas={props.vas as TCartValueAddedServices} />
				</Box>
			)}
			<FlexBox mt='48px' justifyContent={'space-between'}>
				<LencoTypography variant='P_Regular'>Select Products</LencoTypography>
				{/* <LencoTypography variant='P_Regular'>1 items selected</LencoTypography> */}
			</FlexBox>
			{props.itemsGroupedByVasID?.map((productGroups) => {
				return (
					<VasApplicableCartItems
						vasType={props.vas?.type as VAS_TYPES}
						items={productGroups ?? []}
						selectItem={props.selectItem}
						selectedItemsForSelectedVasType={
							props.selectedItemsForSelectedVasType
						}
						key={
							productGroups![0]?.valueAddedServices[
								props.vas?.type as VAS_TYPES
							]?.id
						}
					/>
				);
			})}
		</Box>
	);
};

export default VasCustomization;
